import { Link } from "react-router-dom";

/**
 * ENVIROTEK brand logo — uses the official artwork (green lockup with copper
 * recycling mark + wordmark + tagline).
 * `size` controls the rendered height. `className` is applied to the <img>.
 */
export default function Logo({ className = "", to = "/", testId = "logo-link", size = "h-10 md:h-12" }) {
  const img = (
    <img
      src="/envirotek-logo.webp"
      alt="ENVIROTEK — review · reuse · recycle"
      className={`${size} w-auto rounded-sm select-none ${className}`}
      draggable={false}
    />
  );

  if (to === null) return img;
  return (
    <Link to={to} data-testid={testId} className="inline-flex items-center group" aria-label="ENVIROTEK home">
      {img}
    </Link>
  );
}
